import moment from 'moment';
import { MilestoneHistoryType, StoryHistoryType, CommonHistoryType } from '@/api/history';
import { subscribe } from 'diagnostics_channel';
export const VI = {
  metadata: {
    title: 'EPOSO: Tiêu chuẩn mới cho quản lý dự án IT',
    description:
      'Hãy nâng cao tính minh bạch của dự án IT, cải thiện tỷ lệ tuân thủ lịch trình và quản lý vấn đề hiệu quả với EPOSO. Nâng cao tỷ lệ thành công dự án với giám sát thời gian thực, quản lý lịch trình trực quan và theo dõi vấn đề có hệ thống. Vận hành dự án IT dễ dàng và nhanh chóng hơn cùng EPOSO.',
    keywords:
      'quản lý dự án IT, giám sát dự án, quản lý lịch trình, theo dõi vấn đề, hợp tác nhóm, bảng điều khiển dự án, quản lý phát triển phần mềm, khả năng hiển thị dự án, ngăn chặn chậm trễ dự án, quản lý tài nguyên nhà phát triển, thuê ngoài IT',
  },
  messages: {
    copySuccess: 'Đã sao chép vào khay nhớ tạm.',
    copyFailed: 'Không thể sao chép vào khay nhớ tạm.',
  },
  common: {
    confirm: 'Xác nhận',
    client: 'Khách hàng',
    professional: 'Chuyên gia',
    delete: 'Xóa',
    link: 'Liên kết',
    edit: 'Sửa',
    request: 'Yêu cầu',
    month: 'tháng',
    save: 'Lưu',
    cancel: 'Hủy',
    next: 'Tiếp theo',
    prev: 'Trước',
    add: 'Thêm',
    threadAdd: 'Thêm thảo luận',
    textLengthLimit: (length: number) => `Văn bản trong ${length} ký tự`,
    role: {
      manager: 'Quản lý',
      professional: 'Chuyên gia',
      client: 'Khách hàng',
    },
    webhook: {
      slack: 'Slack',
      teams: 'Teams',
      dooray: 'Dooray',
      discord: 'Discord',
    },
    project: 'Dự án',
    epic: 'Sử thi',
    justAfter: 'Vừa xong',
    minLater: (n: number) => `${n} phút trước`,
    hourLater: (n: number) => `${n} giờ trước`,
    today: 'Hôm nay',
    history: 'Lịch sử',
    none: 'Không có',
    unAssigned: 'Chưa được phân công',
    showMore: 'Xem thêm',
    showLess: 'Thu gọn',
    startDate: 'Ngày bắt đầu',
    endDate: 'Ngày kết thúc',
    formatDt: (date: any, initFormat: string, customFormat: string) =>
      initFormat
        ? moment
            .utc(date, initFormat)
            .local()
            .format(customFormat ? customFormat : 'DD.MM.YYYY')
        : moment(date).format(customFormat ? customFormat : 'DD.MM.YYYY'),
    deleteNoti:
      'Tất cả nội dung sẽ bị xóa và không thể khôi phục. Bạn có chắc chắn muốn xóa không?',
    home: 'Trang chủ',
    story: 'Câu chuyện',
    milestone: 'Mốc quan trọng',
    title: 'Tiêu đề',
    noData: 'Không có dữ liệu.',
    setting: 'Cài đặt',
    status: 'Trạng thái',
    manager: 'Người phụ trách',
    reporter: 'Người báo cáo',
    detail: 'Nội dung',
    send: 'Gửi',
    reject: 'Từ chối',
    sign: 'Ký',
    keyword: 'Từ khóa',
    doclist: 'Tài liệu',
    create: 'Tạo',
    copySuccess: 'Đã sao chép vào clipboard.',
    copyFailed: 'Không thể sao chép vào clipboard.',
    information: 'Thông tin',
  },
  error: {
    apiErrorGeneral: 'Yêu cầu API thất bại.',
  },
  modal: {
    docType: {
      title: 'Tạo tài liệu AI',
      docTypeLabel: 'Loại tài liệu',
      report: 'Báo cáo',
      plan: 'Kế hoạch',
      dateLabel: 'Ngày tham chiếu',
      placeholder: 'Chọn ngày',
      createBtn: 'Tạo',
      cancelBtn: 'Hủy',
      alertSelectDate: 'Vui lòng chọn ngày tham chiếu.',
      alertSelectDocType: 'Vui lòng chọn loại tài liệu.',
      errorPrefix: 'Lỗi: ',
      creatingReport: 'Đang tạo tài liệu...',
      reportIconAlt: 'Biểu tượng báo cáo',
      planIconAlt: 'Biểu tượng kế hoạch',
    },
  },

  component: {
    join: {
      emailAuth: 'Xác thực email',
      emailAuthMsg: `Email sẽ được xác thực khi bạn nhấp vào "Xác thực".`,
      auth: 'Xác thực',
      authComment: [
        'Nếu xác thực không hoạt động bình thường,',
        'vui lòng sao chép liên kết bên dưới và dán vào trình duyệt.',
      ],
    },
    starPost: {
      placeholder: 'Nhập nội dung.',
    },
    stateButton: {
      completed: 'Hoàn thành',
      inProgress: 'Đang tiến hành',
      pending: 'Chờ',
    },
    githubSyncModal: {
      sync: 'Đồng bộ hóa GitHub',
      runSync: 'Chạy Đồng bộ hóa',
      syncRequested: 'Yêu cầu đồng bộ hóa đã được gửi. Chúng tôi sẽ thông báo cho bạn khi hoàn tất.',
      syncStarted: 'Quá trình đồng bộ hóa đã bắt đầu.',
      loadingInitial: 'Đang tải thông tin kết nối...',
      noConnection: 'Không có tài khoản GitHub nào được kết nối.',
      connectFirst: 'Vui lòng kết nối tài khoản GitHub của bạn trước để đồng bộ hóa.',
      connectGithub: 'Kết nối tài khoản GitHub',
      selectAccount: 'Chọn tài khoản',
      selectRepository: 'Chọn kho lưu trữ',
      selectBranch: 'Chọn nhánh',
      githubAccount: 'Tài khoản GitHub',
      repositorySelect: 'Lựa chọn kho lưu trữ',
      branchSelect: 'Lựa chọn nhánh',
      fetchInstallationsFailed: 'Không thể tải thông tin tích hợp GitHub.',
      noAccessibleRepos: 'Không có kho lưu trữ có thể truy cập.',
      connectionRemoved: 'Tích hợp GitHub đã bị xóa và kết nối đã bị xóa. Vui lòng kết nối lại.',
      fetchReposFailed: 'Không thể tải danh sách kho lưu trữ.',
      noBranches: 'Không có nhánh trong kho lưu trữ.',
      fetchBranchesFailed: 'Không thể tải danh sách nhánh.',
      syncFailed: 'Đồng bộ hóa thất bại.',
      connectionSuccess: 'Tài khoản GitHub đã được kết nối thành công.',
      connectionCanceled: 'Người dùng đã hủy kết nối GitHub.',
      connectionError: 'Lỗi xảy ra trong quá trình kết nối GitHub.',
      getInstallUrlFailed: 'Không thể lấy URL cài đặt ứng dụng GitHub.',
      installPageError: 'Lỗi xảy ra khi điều hướng đến trang cài đặt ứng dụng GitHub.',
    },
    githubLinkModal: {
      linkRepository: 'Liên kết kho lưu trữ',
      editRepository: 'Chỉnh sửa thông tin kho lưu trữ',
      linkAction: 'Liên kết',
      editAction: 'Chỉnh sửa',
      linkFailed: 'Liên kết kho lưu trữ thất bại.',
      linkSuccess: 'Đã liên kết kho lưu trữ thành công.',
      editFailed: 'Không thể chỉnh sửa thông tin kho lưu trữ.',
      editSuccess: 'Đã chỉnh sửa thông tin kho lưu trữ thành công.',
      label: 'Nhãn',
      description: 'Mô tả',
      initRepo: 'Khởi tạo Kho lưu trữ',
      initRepoDesc: 'Không tìm thấy nhánh nào. Vui lòng khởi tạo kho lưu trữ để tạo nhánh `main`.',
      initRepoButton: 'Tạo nhánh `main`',
      initSuccess: 'Kho lưu trữ đã được khởi tạo thành công.',
      initFailed: 'Không thể khởi tạo kho lưu trữ.',
    },
    baseInput: {
      errorOccurred: 'Lỗi đã xảy ra:',
    },
    alert: {
      confirm: 'Xác nhận',
      cancel: 'Hủy',
    },
    recruitment: {
      applyTitle: 'Ứng tuyển dự án',
      applyButton: 'Ứng tuyển dự án',
      applySuccess: 'Tin nhắn ứng tuyển đã được gửi đến email người quản lý.',
      editTitle: 'Viết bài đăng tuyển dụng',
      editDelete: 'Xóa',
      editConfirm: 'Viết',
    },
    project: {
      inviteTitle: 'Lời mời dự án',
    },
    gannt: {
      aiScheduleGenerate: 'Tạo lịch trình AI bằng cách tải lên tệp',
      githubSyncTitle: 'Tích hợp và đồng bộ hóa GitHub',
    },
    doclist: {
      clipboardFailed: 'Không thể sao chép vào clipboard.',
    },
    header: {
      convertClient: 'Đã chuyển sang khách hàng.',
      convertProfessional: 'Đã chuyển sang chuyên gia.',
      noLoggedIn: 'Đăng ký và sử dụng dịch vụ',
      loginJoin: 'Đăng nhập/Đăng ký',
      dashboard: 'Bảng điều khiển',
      timeline: 'Lịch trình',
      settlement: 'Thanh toán',
      settings: 'Cài đặt dự án',
      profile: 'Hồ sơ',
      logout: 'Đăng xuất',
      addLink: 'Thêm liên kết',
    },
    noProject: {
      title: 'Không có dự án',
      text: 'Hãy tham gia dự án hoặc tạo dự án mới.',
      button: 'Về trang chủ',
    },
    taskEditor: {
      thread: 'Cuộc thảo luận',
      comment: 'Bình luận',
      commentPlaceholder: 'Nhập nội dung bình luận.',
      enterComment: 'Vui lòng nhập bình luận.',
      record: 'Ghi chép',
      enterYourStory: 'Nhập câu chuyện của bạn.',
      period: 'Thời gian thực hiện',
      progressStatus: 'Trạng thái tiến độ',
      manager: 'Người phụ trách',
      reporter: 'Người báo cáo',
      approvalRequest: 'Yêu cầu phê duyệt',
      approve: 'Phê duyệt',
      reject: 'Từ chối',
      storyComplete: 'Hoàn thành',
      storyReject: 'Từ chối',
      aiTooltip: 'Nhập tiêu đề và nhấp Generate AI để tự động tạo câu chuyện phù hợp với tiêu đề.',
      createSentence: 'Đang tạo câu. Vui lòng chờ một chút.',
      storyPoint: 'Điểm câu chuyện',
      searchAssignee: 'Tìm kiếm người phụ trách',
      searchReporter: 'Tìm kiếm người báo cáo',
      aiGenerating: 'AI đang viết.',
      defaultTitle: 'Viết',
    },
    noComment: {
      text: 'Hãy viết một cuộc thảo luận.',
      title: 'Chưa có cuộc thảo luận nào được viết.',
    },
    taskComment: {
      confirmDelete: 'Bạn có muốn xóa không?',
      confirmCloseComment: 'Có nội dung đang chỉnh sửa. Bạn có chắc chắn muốn thoát không?',
    },
    historyList: {
      getTitleChange: (
        type: MilestoneHistoryType | StoryHistoryType | CommonHistoryType,
        typeTask: 'milestone' | 'story',
      ): string => {
        const storyText = {
          [CommonHistoryType.CREATE]: 'đã thêm câu chuyện.',
          [CommonHistoryType.CHANGE_TITLE]: 'đã thay đổi tiêu đề.',
          [CommonHistoryType.CHANGE_DESCRIPTION]: 'đã thay đổi mô tả.',
          [CommonHistoryType.CHANGE_APPROVER_ASSIGNEE]: 'đã thay đổi người phụ trách.',
          [CommonHistoryType.CHANGE_REPORTER]: 'đã thay đổi người báo cáo.',
          [CommonHistoryType.CHANGE_LINK]: 'đã chỉnh sửa liên kết.',
          [CommonHistoryType.CHANGE_SCHEDULE]: 'đã thay đổi thời gian thực hiện.',
          [CommonHistoryType.CHANGE_STATUS]: 'đã thay đổi trạng thái.',
          [CommonHistoryType.AUTO_CHANGE_STATUS]: 'trạng thái đã được thay đổi.',
          [StoryHistoryType.CHANGE_EPIC]: 'đã thay đổi epic.',
          [CommonHistoryType.CREATE_COMMENT]: 'đã nhập bình luận.',
        };
        const milestoneText = {
          [CommonHistoryType.CREATE]: 'đã thêm mốc quan trọng.',
          [CommonHistoryType.CHANGE_TITLE]: 'đã thay đổi tiêu đề.',
          [CommonHistoryType.CHANGE_DESCRIPTION]: 'đã thay đổi mô tả.',
          [CommonHistoryType.CHANGE_APPROVER_ASSIGNEE]: 'đã thay đổi người phụ trách.',
          [CommonHistoryType.CHANGE_REPORTER]: 'đã thay đổi người báo cáo.',
          [CommonHistoryType.CHANGE_LINK]: 'đã chỉnh sửa liên kết.',
          [CommonHistoryType.CHANGE_SCHEDULE]: 'đã thay đổi thời gian thực hiện.',
          [CommonHistoryType.CHANGE_STATUS]: 'đã thay đổi trạng thái.',
          [CommonHistoryType.AUTO_CHANGE_STATUS]: 'trạng thái đã được thay đổi.',
          [MilestoneHistoryType.REQUEST_APPROVED]: 'đã yêu cầu phê duyệt.',
          [MilestoneHistoryType.APPROVED]: 'đã phê duyệt.',
          [MilestoneHistoryType.REJECT]: 'đã từ chối.',
          [CommonHistoryType.CREATE_COMMENT]: 'đã nhập bình luận.',
        };
        return typeTask === 'milestone'
          ? milestoneText[type as MilestoneHistoryType | StoryHistoryType]
          : storyText[type as CommonHistoryType | StoryHistoryType];
      },
    },
    addRequest: {
      makeRequest: 'Yêu cầu',
      requestPlaceholder: 'Tôi muốn yêu cầu công việc.',
    },
    addContract: {
      makeContract: 'Ký hợp đồng',
      recipient: 'Người nhận',
      sender: 'Người gửi',
    },
    timelineFilter: {
      milestoneStatus: 'Trạng thái mốc quan trọng',
      storyStatus: 'Trạng thái câu chuyện',
      resetFilter: 'Đặt lại bộ lọc',
      keywordPlaceholder: 'Tìm kiếm câu chuyện',
    },
    workingHour: {
      setWorkingHour: 'Thiết lập giờ làm việc',
      workingHour: 'Giờ làm việc',
      commuteTime: 'Thời gian đi làm về',
      applyPeriod: 'Áp dụng hàng loạt cho khoảng thời gian',
    },
    warningSubscription: {
      warning:
        'Số sheet dự án không đủ. Vui lòng tăng số sheet đăng ký trong vòng 3 ngày hoặc xóa người phụ trách. Sau đó bạn sẽ không thể sử dụng dự án.',
    },
    githubSync: {
      githubSync: 'Đồng bộ Github',
      runSync: 'Chạy đồng bộ',
    },
  },
  views: {
    home: {
      slideItem: [
        {
          title: `Hãy tự do <span>chọn thời gian</span> để làm việc.`,
          subtext: `Bạn có thể thiết lập thời gian làm việc của freelancer trong story.<br>Hãy nhận thanh toán theo thời gian bạn đã làm việc.`,
        },
        {
          title: `Bạn có bối rối <span>nên giao dự án cho ai</span> không?`,
          subtext: `Hãy đăng thông báo phát triển trên Eposo.<br>Kiểm tra hồ sơ ứng viên và ký hợp đồng.`,
        },
        {
          title: `<span>Nội dung phát triển</span> có khác với suy nghĩ của bạn không?`,
          subtext: `Hãy giảm rủi ro phát triển thông qua giao tiếp giữa khách hàng và chuyên gia.<br>Tại Eposo, khách hàng và chuyên gia thảo luận và tiến hành phát triển theo từng giai đoạn.`,
        },
      ],
      slogan: 'Đổi mới quản lý dự án IT',
      landingWrap: [
        'EPOSO giải quyết tính không minh bạch trong quản lý dự án IT, chậm trễ lịch trình và khó khăn trong quản lý vấn đề.',
        'EPOSO đưa ra tiêu chuẩn quản lý dự án IT thay đổi theo thời gian thực.',
      ],
      go: 'Miễn phí tạo dự án',
      point: 'Tính năng ',
      onPrepared: 'Đang chuẩn bị ra mắt',
      onPreparedShort: 'Đang chuẩn bị',
      pointText: [
        {
          title: 'Theo dõi vấn đề có hệ thống',
          text: [
            'Đăng ký và theo dõi ngay lập tức các vấn đề phát sinh trong quá trình thực hiện dự án.',
            'Quản lý minh bạch quá trình giải quyết vấn đề để giảm rủi ro dự án.',
          ],
          comment: 'Bạn có thể dễ dàng kiểm tra các vấn đề bị trì hoãn.',
        },
        {
          title: 'Quản lý lịch trình hiệu quả',
          text: [
            'Quản lý lịch trình phức tạp một cách có hệ thống với giao diện trực quan.',
            'Quản lý lịch trình trở nên dễ dàng hơn với việc hiển thị timeline.',
          ],
          comment: 'Việc quản lý lịch trình trở nên dễ dàng hơn nhờ hiển thị timeline.',
        },
        {
          title: 'Quản lý dự án minh bạch',
          text: [
            'Nắm bắt toàn bộ dự án một cách nhanh chóng với bảng điều khiển thời gian thực.',
            'Có thể ra quyết định nhanh chóng bằng cách thấy rõ tình hình tiến độ.',
          ],
          comment:
            'Bạn có thể giảm lo lắng của nhau bằng cách nhận sự chấp thuận từ khách hàng và bắt đầu công việc.',
        },
        {
          title: 'Quản lý nhân lực chính xác',
          text: [
            'Quản lý hiệu quả tình hình đầu tư nhân lực và tỷ lệ tham gia.',
            'Độ chính xác và hiệu quả của việc thanh toán dự án được nâng cao.',
          ],
          comment: 'Hãy thanh toán một cách đơn giản theo thời gian bạn đã làm việc trong dự án.',
        },
        {
          title: 'Kết nối nhân tài toàn cầu',
          text: [
            'Kết nối các dự án với nhân tài xuất sắc từ nhiều khu vực khác nhau.',
            'Bạn có thể dễ dàng tìm được nhân tài phù hợp nhất cho dự án.',
          ],
          comment: 'Hãy đăng dự án cần phát triển để tuyển dụng ứng viên.',
        },
        {
          title: 'Tạo dự án tự động bằng AI',
          text: [
            'Tự động tạo dự án chỉ với một vài câu hỏi.',
            'Nhận danh sách tính năng phát triển do AI đề xuất và bắt đầu phát triển ngay lập tức.',
          ],
          comment: 'AI tạo dự án một cách dễ dàng cho bạn.',
        },
      ],
      pointImg: [
        require('@/assets/images/main/randing1.png'),
        require('@/assets/images/main/randing2.png'),
        require('@/assets/images/main/randing3.png'),
        require('@/assets/images/main/randing4.png'),
        require('@/assets/images/main/randing5.png'),
        require('@/assets/images/main/randing6.png'),
        require('@/assets/images/main/randing7.png'),
      ],
      tail: [
        'Hãy nâng cao khả năng hiển thị dự án và tối đa hóa hiệu quả quản lý với EPOSO.',
        'Sự khởi đầu của quản lý dự án có hệ thống hơn, hãy cùng EPOSO.',
      ],
    },
    login: {
      title: ['Đăng ký đơn giản với SNS', 'và sử dụng dịch vụ'],
      googleLogin: 'Đăng nhập dễ dàng với Google',
      emailLogin: 'Đăng nhập email',
      emailId: 'Email ID',
      password: 'Mật khẩu',
      join: 'Đăng ký thành viên',
      find: 'Tìm tài khoản',
      error: [
        'Mật khẩu không chính xác.',
        'Không có thông tin tài khoản phù hợp.',
        'Đã bị khóa do nhập sai quá 5 lần. Vui lòng đặt lại mật khẩu.',
        'Đăng nhập thất bại. Vui lòng thử lại.',
      ],
      toast: [
        '',
        'Email đã được gửi.',
        'Truy cập không hợp lệ.',
        'Mật khẩu đã được thay đổi.',
        '',
        'Email đã được xác thực.',
        'Xác thực email thất bại.',
        'Đã xử lý rút khỏi thành viên.',
        'Hãy thử đăng nhập bằng email.',
      ],
    },
    dashboard: {
      process: 'Tiến hành / Kế hoạch',
      milestone: 'Mốc quan trọng',
      timeCost: 'Thời gian tiêu tốn',
      request: 'Yêu cầu',
      procRate: 'Tỷ lệ tiến độ',
      approvalRequest: 'Yêu cầu phê duyệt',
      status: 'Trạng thái',
      approvalDate: 'Ngày phê duyệt',
      approval: 'Phê duyệt',
      withdrawal: 'Từ chối',
      approved: 'Đã phê duyệt',
      processStart: 'Ngày bắt đầu',
      processEnd: 'Ngày hoàn thành',
      noApprovalRequest: {
        title: 'Không có nội dung yêu cầu phê duyệt.',
        text: 'Bạn có thể viết milestone và nhận sự chấp thuận từ khách hàng.',
      },
      milestoneProc: 'Tình hình tiến độ milestone',
      noMilestones: {
        title: 'Không có milestone.',
        text: 'Thời gian tiến hành của milestone sẽ được hiển thị.',
      },
      myRequests: 'Dịch vụ yêu cầu của tôi',
      assignee: 'Người phụ trách',
      requestDate: 'Ngày yêu cầu',
      completeDate: 'Ngày hoàn thành',
      noRequests: {
        title: 'Không có dịch vụ được yêu cầu.',
        text: 'Hãy yêu cầu công việc từ người liên quan đến dự án.',
      },
      myContract: 'Tình hình hợp đồng của tôi',
      contract: 'Hợp đồng',
      index: 'Phân biệt',
      target: 'Đối tượng',
      sendDate: 'Ngày gửi',
      contractDate: 'Ngày ký hợp đồng',
      send: 'Gửi',
      receive: 'Nhận',
      noContract: {
        title: 'Không có hợp đồng đã tiến hành.',
        text: 'Hãy tiến hành hợp đồng giữa các bên liên quan đến dự án.',
      },
      progressStory: 'Story đang tiến hành',
      noProgressStory: {
        title: 'Không có story đang tiến hành.',
        text: 'Vui lòng thiết lập lịch trình story trong trang lịch trình.',
      },
      holdStory: 'Story đang bị trì hoãn',
      noHoldStory: {
        title: 'Không có story bị trì hoãn.',
        text: 'Vui lòng hoàn thành story trước ngày kết thúc.',
      },
    },
    timeline: {
      status: 'Trạng thái',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      addMilestone: 'Thêm milestone',
      waitingStories: 'Story đang chờ',
      addStory: 'Thêm story',
      creatingTimelineAI: 'Đang tạo timeline bằng AI...',
    },
    setting: {
      addProject: 'Thêm dự án',
      projectPeriod: 'Thời gian dự án',
      startDate: 'Ngày bắt đầu',
      endDate: 'Ngày kết thúc',
      startDateShorter: 'Ngày bắt đầu',
      endDateShorter: 'Ngày kết thúc',
      dateError: 'Ngày sau không thể sớm hơn ngày trước.',
      addAsMember: 'Thêm bằng email người phụ trách',
      member: 'Người phụ trách',
      email: 'Email',
      company: 'Công ty',
      role: 'Vai trò',
      assign: 'Phân công',
      auth: 'Quyền hạn',
      unfold: 'Mở rộng',
      epic: 'Epic',
      weight: 'Trọng số',
      addEpic: 'Thêm epic',
      deleteProject: 'Xóa dự án',
      askDelete: [
        'Bạn có chắc chắn muốn xóa không?',
        'Tất cả nội dung dự án sẽ bị xóa và không thể khôi phục!',
      ],
      notValidEmail: 'Định dạng email không hợp lệ.',
      successAddMember: 'Thêm thành viên thành công.',
      epicLimit: 'Số lượng epic được thiết lập tối đa 30 cái.',
      deleteAsk: 'Bạn có chắc chắn muốn xóa không?',
      cardRegist: 'Đăng ký thẻ thành công.',
      addWebhook: 'Thêm webhook',
      webhookLink: 'URL liên kết webhook',
      successAddWebhook: 'Thêm webhook thành công.',
      notValidUrl: 'Định dạng URL không hợp lệ.',
      webhookLabel: {
        type: 'Phân loại',
        url: 'URL',
        milestone: 'Milestone',
        story: 'Story',
        request: 'Yêu cầu',
        write: 'Mới',
        update: 'Cập nhật',
        delete: 'Xóa',
      },
      // Project Token
      figmaTokenScopeNote:
        'Khi tạo token Figma, vui lòng thêm quyền file_content:read vào scope.',
      couponRegist: 'Coupon đã được đăng ký bình thường.',
      couponRegistFail: 'Đăng ký coupon thất bại.',
      couponExpiredOrNone: 'Coupon đã hết hạn hoặc không tồn tại.',
      couponIsMontly: 'Coupon dành cho thanh toán hàng tháng.',
      couponIsYearly: 'Coupon dành cho thanh toán hàng năm.',
      couponAlreadyRegisterd: 'Coupon đã được đăng ký.',
      cardRegistFail: 'Đăng ký thẻ thất bại.',
      subscribe: 'Đăng ký thành công.',
      subscribeFail: 'Đăng ký thất bại.',
      refund: 'Hoàn tiền thành công.',
      enterCoupon: 'Vui lòng nhập số coupon.',
      refundFail: 'Hoàn tiền thất bại.',
      subscribeAdd: 'Thêm số đăng ký thành công.',
      subscribeAddFail: 'Thêm số đăng ký thất bại.',
      usedSheets: 'Sheet đã sử dụng',
      sheets: 'Sheet',
      sheet: 'Sheet',
      free: 'Miễn phí',
      paid: 'Có phí',
      aiTokensBaseCapTooltip: 'Tùy theo số lượng seat đăng ký, token cơ bản có thể được cấp thêm.',
      aiTokensPayNow: 'Thanh toán ngay khoản nợ',
      aiTokensPayNowSuccess: 'Đã yêu cầu thử lại thanh toán.',
      aiTokensTestConsume: 'Khấu trừ thử',
      aiTokensTestConsumeTitle: 'Khấu trừ thử',
      aiTokensTestConsumeSubmit: 'Khấu trừ',
      aiTokensTestConsumeAmount: 'Số token khấu trừ',
      aiTokensTestConsumeFeature: 'feature',
      aiTokensTestConsumeIdempotencyKey: 'Khóa idempotency',
      aiTokensTestConsumeIdempotencyKeyPh: 'Không bắt buộc (server tự tạo nếu để trống)',
      aiTokensTestConsumeMeta: 'Ghi chú',
      aiTokensTestConsumeMetaPh: 'Khấu trừ thử từ frontend',
      subscription: 'Đăng ký',
      subscriptionChange: 'Thay đổi đăng ký',
      paymentManagement: 'Quản lý thanh toán',
      registerSubscription: 'Đăng ký subscription',
      paymentInfo: 'Thông tin thanh toán',
      usingForFree: 'Đang sử dụng miễn phí',
      usingMonthly: 'Đang đăng ký hàng tháng',
      usingYearly: 'Đang đăng ký hàng năm',
      subscriptionInfo: 'Thông tin đăng ký',
      paymentCard: 'Thẻ thanh toán',
      paymentCurrency: 'Tiền tệ thanh toán',
      coupon: 'Coupon đang sử dụng',
      useCoupon: 'Sử dụng',
      couponInUse: 'Đang sử dụng',
      selectCoupon: 'Chọn coupon',
      registerCoupon: 'Đăng ký coupon',
      couponNumber: 'Số coupon',
      registerWord: 'Đăng ký',
      availableCoupon: 'Coupon đang sở hữu',
      choose: 'Chọn',
      nextPaymentDate: 'Ngày thanh toán tiếp theo',
      paymentHistory: 'Lịch sử thanh toán',
      registerCard: 'Đăng ký thẻ',
      notRegistered: 'Chưa đăng ký',
      agreeToTerms: 'Tôi đồng ý với các điều khoản',
      agreeToPayment: 'Tôi đồng ý với việc thanh toán',
      noRecordForPayment: 'Không có lịch sử thanh toán.',
      cardNumber: 'Số thẻ',
      expirationDate: 'Ngày hết hạn',
      birthDate: 'Ngày sinh',
      businessRegNum: 'Số đăng ký kinh doanh',
      businessRegNumPh: "Số đăng ký kinh doanh (nhập không có '-')",
      corporateCard: 'Thẻ công ty',
      ownerName: 'Tên chủ sở hữu',
      password: 'Mật khẩu',
      partial: 'Một phần',
      full: 'Toàn bộ',
      cancel: 'Hủy',
      save: 'Lưu',
      close: 'Đóng',
      monthWord: 'tháng',
      yearWord: 'năm',
      subscribeWord: 'Đăng ký',
      subscriptionSheets: 'Sheet đăng ký',
      paymentMethod: 'Phương thức thanh toán',
      monthlyPlanPrice: 'Phí đăng ký hàng tháng',
      yearlyPlanPrice: 'Phí đăng ký hàng năm',
      monthlySubscription: 'Thanh toán hàng tháng',
      yearlySubscription: 'Thanh toán trước hàng năm',
      subscriptionPeriod: 'Thời gian đăng ký',
      paymentAmount: 'Số tiền thanh toán',
      addtionalWord: 'Thêm',
      addedCost: 'Số tiền thanh toán thêm',
      basicDiscountWord: 'Giảm giá cơ bản',
      couponDiscountWord: 'Giảm giá',
      refundHistory: 'Lịch sử hoàn tiền',
      refundWord: 'Hoàn tiền',
      amountWord: 'Số tiền',
      payWord: 'Thanh toán',
      priceWord: 'Giá',
      totalRefundAmount: 'Tổng số tiền hoàn lại',
      termLanguage: 'VI',
      currency: 'đồng',
      sheetsAvailable: 'Sheet có thể sử dụng',
      total: 'Tổng',
      day: 'ngày',
      days: 'ngày',
      use: 'Sử dụng',
      used: 'Đã sử dụng',
      times: 'lần',
      currencyType: 'Phương thức thanh toán',
      currencyKrw: 'Thanh toán bằng won (KRW)',
      currencyUsd: 'Thanh toán quốc tế (USD)',
      currencyKrw2: 'Phương thức thanh toán KRW',
      currencyUsd2: 'Phương thức thanh toán USD',
      currencyKrw2Desc: 'Chỉ có thể sử dụng thẻ có thể thanh toán trong Hàn Quốc.',
      currencyUsd2Desc: 'Chỉ có thể sử dụng thẻ có thể thanh toán quốc tế.',
      cvv: 'cvv',
      firstName: 'Tên',
      lastName: 'Họ',
      phoneNumber: 'Số điện thoại',
      address: 'Địa chỉ',
      city: 'Thành phố',
      state: 'Tỉnh/Bang',
      zipcode: 'Mã bưu điện',
      country: 'Quốc gia',
      placeholder: {
        address: 'Vui lòng nhập địa chỉ',
        city: 'Vui lòng nhập thành phố',
        state: 'Vui lòng nhập tỉnh/bang',
        zipCode: 'Vui lòng nhập mã bưu điện',
      },
      aiProjectCreate: 'Tạo dự án với AI',
      aiProjectCreateDesc:
        'AI sẽ giúp bạn khởi động dự án. Mô tả dự án của bạn và tự động tạo ra mọi thứ từ danh sách tính năng đến lịch trình phát triển.',
      generateAI: 'Tạo AI',
      inviting: 'Đang mời',
      expert: 'Chuyên gia',
      adminRequired: 'Dự án cần ít nhất một quản trị viên.',
      select: 'Chọn',
    },
    profile: {
      editPhoto: 'Chỉnh sửa ảnh',
      nickname: 'Biệt danh',
      personalColor: 'Màu cá nhân',
      language: 'Ngôn ngữ',
      languages: {
        kr: 'Tiếng Hàn',
        en: 'Tiếng Anh',
        vi: 'Tiếng Việt',
      },
      email: 'Email',
      authEmail: 'Xác thực email',
      name: 'Tên',
      phone: 'Số điện thoại di động',
      numberOnly: 'Vui lòng chỉ nhập số.',
      birth: 'Ngày sinh',
      gender: 'Giới tính',
      male: 'Nam',
      female: 'Nữ',
      task: 'Công việc',
      job: 'Nghề nghiệp',
      taskType: 'Tính chất công việc',
      freelancer: 'Freelancer',
      officer: 'Nhân viên chính thức',
      hopeLaborDay: 'Mức lương mong muốn theo ngày',
      pricePerDay: 'nghìn đồng / 8 giờ',
      company: 'Công ty',
      career: 'Kinh nghiệm',
      deleteCareer: 'Xóa kinh nghiệm',
      companyName: 'Tên công ty',
      workPeriod: 'Thời gian làm việc',
      dateError: 'Ngày kết thúc không thể sớm hơn ngày bắt đầu.',
      level: 'Cấp bậc/Chức vụ',
      salaryYear: 'Lương năm (nghìn đồng)',
      addCareer: 'Thêm kinh nghiệm',
      setAccount: 'Cài đặt tài khoản',
      addProfile: 'Đăng ký hồ sơ',
      account: 'Tài khoản',
      withdrawAccount: 'Rút khỏi thành viên',
      resetPassword: 'Đặt lại mật khẩu',
      agreeMarketing: 'Đồng ý tiếp thị',
      agreedAt: 'Thời gian đồng ý',
      notification: 'Thông báo',
      notiAll: 'Tất cả thông báo',
      notiAllMsg: 'Nhận tất cả thông báo.',
      notiEmail: 'Thông báo email',
      notiEmailMsg: 'Nhận thông báo qua Email đã thiết lập.',
      notiNewTask: 'Thông báo công việc mới',
      notiNewTaskMsg: 'Nhận thông báo khi được chỉ định làm người phụ trách.',
      notiDelayed: 'Thông báo trì hoãn',
      notiDelayedMsg: 'Nhận thông báo khi có story bị trì hoãn.',
      notiReq: 'Thông báo yêu cầu công việc',
      notiReqMsg: 'Nhận thông báo khi có yêu cầu mới cho tôi.',
      withdrawAsk: (nickname: string) =>
        `${nickname}, bạn có chắc chắn muốn rút khỏi thành viên không?`,
      withdrawMsg: [
        'Nếu bạn rút khỏi thành viên ngay bây giờ, khi xảy ra vấn đề với các công việc đang tiến hành hoặc dự kiến tiến hành,',
        'công ty khách hàng có thể yêu cầu bồi thường thiệt hại.',
        'Nếu bạn rút khỏi thành viên ngay bây giờ, tất cả dữ liệu trong tài khoản hiện tại sẽ biến mất.',
        'Ngay cả khi bạn đăng ký lại với cùng một tài khoản sau này, dữ liệu sẽ không được khôi phục.',
      ],
      giveFeedback: 'Xin hãy cho chúng tôi phản hồi!',
      feedbackPlaceholder:
        'Bạn có thể cho biết lý do rút khỏi dịch vụ không?&#10;Nếu bạn cho phản hồi về những phần đáng tiếc, sẽ giúp rất nhiều cho việc cải thiện dịch vụ.',
      withdrawCheckbox: 'Tôi đã xác nhận và đồng ý với những lưu ý khi rút khỏi thành viên.',
      resetPasswordSent: 'Email đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra email.',
      success: 'Đăng ký hồ sơ thành công.',
      askDelete: 'Bạn có chắc chắn muốn xóa không?',
      careerFull: 'Không thể thêm kinh nghiệm nữa.',
    },
    epic: {
      epic: 'Epic',
      epicLabel: 'Nhãn epic',
      point: 'Điểm',
      weight: 'Tỷ trọng',
      progress: 'Tiến độ',
      progressGap: 'Chênh lệch tiến độ',
    },
    payment: {
      paymentFailure: 'Thanh toán thất bại',
      paymentFailureMessage: 'Thanh toán thất bại.',
      paymentSuccess: 'Thanh toán thành công',
      paymentSuccessMessage: 'Thanh toán đã hoàn tất.',
      confirm: 'Xác nhận',
      close: 'Đóng',
    },
    doclist: {
      share: 'Chia sẻ',
      permission: 'Quyền hạn',
      addAiDoc: 'Tạo tài liệu bằng AI',
      searchPlaceholder: 'Nhập từ khóa tìm kiếm...',
      aiEdit: 'Chỉnh sửa bằng AI',
      aiEditTitle: 'Chỉnh sửa tài liệu với AI',
      aiEditConfirm: 'Áp dụng chỉnh sửa',
      aiEditPromptLabel: 'Hướng dẫn chỉnh sửa',
      aiEditPromptPlaceholder: 'vd) Cải thiện bảng, tăng cường kết luận, loại bỏ câu trùng lặp',
      aiEditNote: 'Máy chủ chỉ trả về HTML đã chỉnh sửa. Nhấn áp dụng sẽ tự động lưu.',
      aiEditLoading: 'AI đang chỉnh sửa tài liệu...',
      loading: 'Đang tải...',
      addDoc: 'Thêm tài liệu',
      addFolder: 'Thêm thư mục',
      selectDocumentPlaceholder: 'Vui lòng chọn tài liệu',
      selectDocumentContentPlaceholder: 'Chọn tài liệu để xem hoặc chỉnh sửa nội dung.',
      reportCreatedSuccess: 'Báo cáo AI đã được tạo thành công.',
      confirm: {
        unsavedChanges: 'Có thay đổi chưa được lưu. Bạn có muốn tiếp tục không?',
        delete:
          'Bạn có muốn xóa tài liệu {title} không? Nếu là thư mục, tất cả tài liệu/thư mục con cũng sẽ bị xóa.',
        deleteSimple:
          'Bạn có muốn xóa tài liệu không? Nếu là thư mục, tất cả mục con cũng sẽ bị xóa.',
      },
      toast: {
        aiEditApplied: 'Kết quả chỉnh sửa AI đã được áp dụng.',
        addSuccess: '{title} đã được thêm.',
        addFail: 'Thêm tài liệu thất bại.',
        fetchFail: 'Tải danh sách tài liệu thất bại.',
        fetchContentFail: 'Tải nội dung tài liệu thất bại.',
        titleEmpty: 'Tiêu đề không được để trống.',
        titleUpdateSuccess: 'Tiêu đề đã được cập nhật thành công.',
        titleUpdateFail: 'Cập nhật tiêu đề thất bại.',
        fetchChildrenFail: 'Tải mục con của {title} thất bại.',
        addSubSuccess: 'Tài liệu con đã được thêm.',
        addSubFail: 'Thêm tài liệu con thất bại.',
        addRootSuccess: 'Tài liệu mới đã được thêm.',
        addRootFail: 'Thêm tài liệu mới thất bại.',
        addFolderSuccess: 'Thư mục mới đã được thêm.',
        addFolderFail: 'Thêm thư mục mới thất bại.',
        positionSaveFail: 'Lưu vị trí mới thất bại. Đang hoàn nguyên.',
        initFail: 'Lỗi xảy ra trong quá trình khởi tạo component.',
        invalidProject: 'Truy cập dự án không hợp lệ.',
        contentSaveSuccess: 'Nội dung tài liệu đã được lưu.',
        contentSaveFail: 'Lưu nội dung tài liệu thất bại.',
        shareLinkCopied: 'Liên kết chia sẻ đã được sao chép vào clipboard.',
        deleteSuccess: 'Tài liệu đã được xóa.',
        deleteFail: 'Xóa tài liệu thất bại.',
      },
      alt: {
        search: 'Tìm kiếm',
        close: 'Đóng',
        editDelete: 'Chỉnh sửa/Xóa',
        comment: 'Bình luận',
        history: 'Lịch sử',
      },
    },
    join: {
      profileSetup: 'Vui lòng thiết lập hồ sơ của bạn.',
      photoRegistration: 'Đăng ký ảnh',
      nickname: 'Biệt danh',
      nicknamePlaceholder: '15 ký tự hoặc ít hơn',
      personalColor: 'Màu cá nhân',
      email: 'Email',
      emailPlaceholder: 'example@eposo.ai',
      password: 'Mật khẩu',
      passwordPlaceholder: '10 ký tự trở lên',
      passwordValidation: 'Vui lòng nhập văn bản từ 10 đến 20 ký tự.',
      passwordConfirm: 'Xác nhận mật khẩu',
      passwordMismatch: 'Mật khẩu không khớp.',
      name: 'Tên',
      phoneNumber: 'Số điện thoại',
      phonePlaceholder: 'Vui lòng nhập số',
      birthday: 'Ngày sinh',
      gender: 'Giới tính',
      male: 'Nam',
      female: 'Nữ',
      agree: 'Tôi đồng ý với các điều khoản và điều kiện.',
      optional: '(Tùy chọn)',
      joinButton: 'Tham gia',
      emailVerification: 'Xác thực email',
      emailVerifying: 'Xác thực email',
      emailVerified: 'Email đã xác thực',
      verify: 'Xác thực',
      invalidEmail: 'Định dạng email không hợp lệ.',
      emailAlreadyUsed: 'Email đã được đăng ký.',
      emailSent: 'Một email xác thực đã được gửi đến email của bạn.',
      joinComplete: 'Tham gia thành công. Vui lòng đăng nhập.',
      sessionExpired: 'Phiên đã hết hạn. Vui lòng làm mới trang để bảo mật thông tin cá nhân.',
      joinSuccess: 'Tham gia thành công!',
    },
    pilot: {
      title: 'Pilot Page',
      description: 'This is the page for the auto-coding feature.',
      noHistory: 'Lịch sử mã hóa AI không tồn tại.',
      registeredRepositories: 'Kho lưu trữ đã đăng ký',
      addRepository: 'Thêm kho lưu trữ',
      noRepositoryLinked: 'Không có kho lưu trữ nào được liên kết.',
      loadingHistory: 'Đang tải lịch sử...',
      loadingRepositories: 'Đang tải kho lưu trữ...',
      aiCodingHistory: 'Lịch sử mã hóa AI',
      deleteRepoConfirm: 'Bạn có chắc chắn muốn xóa kho lưu trữ đã liên kết không?',
      unlinkSuccess: 'Đã hủy liên kết kho lưu trữ thành công.',
      unlinkFailed: 'Không thể hủy liên kết kho lưu trữ.',
      viewPr: 'Xem PR',
      loadingStories: 'Đang tải danh sách câu chuyện...',
      unclassified: 'Chưa phân loại',
      loadingStoriesPlaceholder: 'Đang tải câu chuyện...',
      startAiCoding: 'Tác vụ mã AI',
      runAiCoding: 'Chạy tác vụ mã hóa AI',
      instruction: 'Hướng dẫn',
      instructionPlaceholder: 'Nhập hướng dẫn mã hóa cụ thể cho AI. (ví dụ: "Thêm điểm cuối API đăng nhập.")',
      filePath: 'Đường dẫn tệp mục tiêu',
      filePathPlaceholder: 'Nhập đường dẫn đầy đủ của tệp để sửa đổi hoặc thêm. (ví dụ: "src/user/user.service.ts")',
      relatedStory: 'Câu chuyện liên quan',
      selectStory: 'Chọn một câu chuyện',
      run: 'Chạy',
      taskStarted: 'Tác vụ mã hóa AI đã bắt đầu. Bạn có thể kiểm tra trạng thái trong lịch sử.',
      taskStartFailed: 'Không thể bắt đầu tác vụ mã hóa AI.',
      fetchStoriesFailed: 'Không thể tải danh sách câu chuyện.',
      generateInstruction: 'Tạo hướng dẫn AI',
      generatingInstruction: 'AI đang tạo hướng dẫn...',
      generateInstructionFailed: 'Không thể tạo hướng dẫn.',
      autoCodingSettings: 'Cài đặt mã hóa tự động',
      autoApprovePRs: 'Tự động phê duyệt PR do AI tạo',
      autoApprovePRsDesc: 'Khi được bật, các PR do AI tạo sẽ được tự động phê duyệt.',
      fetchSettingsFailed: 'Không thể tải cài đặt.',
      updateSettingsSuccess: 'Cài đặt được cập nhật thành công.',
      updateSettingsFailed: 'Không thể cập nhật cài đặt.',
      enableAutoRetry: 'Auto-retry on deployment failure',
      enableAutoRetryDesc: 'If enabled, AI will automatically try to fix the code upon deployment failure.',
      webhookIntegration: 'Tích hợp Webhook',
      webhookIntegrationDesc:
        'Để tự động theo dõi trạng thái triển khai khi các PR do AI Coder tạo được hợp nhất, hãy đăng ký URL webhook trong nền tảng triển khai của bạn theo hướng dẫn bên dưới.',
      webhookVercelDesc: 'Kiểm tra tích hợp GitHub trong menu Cài đặt > Tích hợp của dự án Vercel của bạn. Khi một PR từ Eposo AI được hợp nhất, Vercel sẽ tự động bắt đầu triển khai và cập nhật trạng thái trên GitHub.',
      webhookRailwayDesc: 'Đi tới menu Cài đặt > Webhooks của dự án Railway của bạn và đăng ký URL.',
      repoAndTargetManagement: 'Quản lý Kho chứa & Mục tiêu triển khai',
      noRepositories: 'Không có kho chứa nào được đăng ký. Vui lòng cài đặt ứng dụng GitHub và đăng ký một kho chứa.',
      addDeploymentTarget: 'Thêm mục tiêu triển khai',
      editDeploymentTarget: 'Chỉnh sửa mục tiêu triển khai',
      noDeploymentTargets: 'Không có mục tiêu triển khai nào được đăng ký.',
      deploymentTargetLabel: 'Nhãn',
      deploymentPlatform: 'Nền tảng',
      serviceIdentifier: 'Mã định danh Dịch vụ',
      apiToken: 'Mã API',
      deploymentTargetLabelPlaceholder: 'Ví dụ: Eposo Web Frontend (Production)',
      serviceIdentifierPlaceholderVercel: "Vercel: Cài đặt Dự án > Chung > ID Dự án",
      serviceIdentifierPlaceholderRailway: "Railway: Dịch vụ > Cài đặt > ID Dịch vụ",
      apiTokenPlaceholder: 'Dùng để phân tích nhật ký triển khai/thử lại',
      apiTokenPlaceholderVercel: 'Nhập mã API Vercel của bạn',
      apiTokenPlaceholderRailway: 'Nhập mã API Railway của bạn',
      noEnvironmentVariables: 'Không có biến môi trường nào được đặt. Các biến môi trường cần thiết sẽ được tự động phát hiện và thêm vào trong các tác vụ mã hóa AI.',
      setupGuide: 'Hướng dẫn cài đặt',
      confirmDeleteDeploymentTarget: 'Bạn có chắc chắn muốn xóa mục tiêu triển khai này không?',
      fetchRepositoriesFailed: 'Failed to fetch registered repositories.',
      fetchDeploymentTargetsFailed: 'Failed to fetch deployment targets.',
      updateDeploymentTargetSuccess: 'Deployment target updated successfully.',
      addDeploymentTargetSuccess: 'Deployment target added successfully.',
      saveDeploymentTargetFailed: 'Failed to save deployment target.',
      deleteDeploymentTargetSuccess: 'Deployment target deleted successfully.',
      deleteDeploymentTargetFailed: 'Failed to delete deployment target.',
      environmentVariables: 'Biến môi trường',
      fetchEnvironmentsFailed: 'Không thể tải các biến môi trường.',
      updateEnvironmentSuccess: 'Biến môi trường đã được cập nhật thành công.',
      updateEnvironmentFailed: 'Không thể cập nhật biến môi trường.',
      generate: 'Tạo',
      secretGenerated: 'Một giá trị bí mật mới đã được tạo. Vui lòng nhấn Lưu.',
      resyncButtonText: 'Đồng bộ hóa biến môi trường',
      resyncingButtonText: 'Đang đồng bộ hóa...',
      resyncFailedMessage: 'Yêu cầu đồng bộ hóa biến môi trường thất bại.',
      resyncTooltipText:
        'Quét mã hiện tại và các nền tảng triển khai (Vercel, Railway) để đồng bộ hóa các biến môi trường về trạng thái mới nhất. Các biến không sử dụng sẽ tự động bị xóa.',
      addTargetTooltipText: 'Đăng ký thông tin dự án Vercel hoặc Railway nơi mã sẽ được triển khai.',
      resyncInProgress: 'Một tác vụ đồng bộ hóa biến môi trường đã đang được tiến hành.',
      resyncSuccess: 'Đồng bộ hóa biến môi trường đã hoàn tất thành công.',
      resyncFailed: 'Đồng bộ hóa biến môi trường đã thất bại. Vui lòng kiểm tra nhật ký.',
      resyncStatusFailed: 'Đồng bộ hóa thất bại',
      taskInProgress: 'Một tác vụ mã hóa tự động đã đang được tiến hành.',
      aiSetup: 'Thiết lập AI',
      autoSetupSuccess: 'Giá trị biến môi trường đã được thiết lập tự động.',
      autoSetupFailed: 'Không thể tự động thiết lập biến môi trường.',
      status: {
        pending: 'Đang chờ',
        in_progress: 'Đang tiến hành',
        succeeded: 'Thành công',
        failed: 'Thất bại',
        cancelled: 'Đã hủy',
        pending_review: 'Chờ xem xét',
        retrying: 'Đang thử lại',
      },
      deploymentStatus: {
        deploying: 'Đang triển khai',
        verifying: 'Đang xác minh',
        verification_failed: 'Xác minh thất bại',
        succeeded: 'Triển khai thành công',
        failed: 'Triển khai thất bại',
      },
      deploy: 'Triển khai',
      deployStartedSuccess: 'Đã bắt đầu triển khai thành công.',
      deployStartedFailed: 'Không thể bắt đầu triển khai.',
      runDeployment: 'Chạy triển khai thủ công',
      selectRepository: 'Chọn Repository',
      selectRepositoryPlaceholder: 'Vui lòng chọn một repository để triển khai.',
      startDeployment: 'Triển khai mới',
      runAiCodeTask: 'Chạy tác vụ mã AI',
      repoName: 'Kho lưu trữ',
      branchName: 'Nhánh',
      createdAt: 'Ngày tạo',
      workSummary: 'Tóm tắt công việc',
      viewWorkSummary: 'Xem tóm tắt',
      viewLogs: 'Xem nhật ký',
    },
  },
  status: {
    timeline: {
      completed: 'Hoàn thành',
      inProgress: 'Đang tiến hành',
      pending: 'Chờ',
      delayed: 'Trì hoãn',
      considering: 'Đang xem xét',
      rejected: 'Từ chối',
      approving: 'Đang phê duyệt',
      approved: 'Đã phê duyệt',
    },
    request: {
      awaiting: 'Chờ',
      inProgress: 'Đang tiến hành',
      completed: 'Hoàn thành',
    },
    contract: {
      completed: 'Hoàn thành',
      inProgress: 'Đang tiến hành',
      rejected: 'Từ chối',
    },
  },
  validation: {
    email: {
      registered: 'Email đã được đăng ký.',
      invalidFormat: 'Định dạng email không hợp lệ.',
    },
    name: {
      required: 'Vui lòng nhập tên.',
      maxLength15: 'Vui lòng viết trong 15 ký tự.',
    },
    nickname: {
      required: 'Vui lòng nhập biệt danh.',
      maxLength15: 'Vui lòng viết trong 15 ký tự.',
    },
    password: {
      length: 'Vui lòng nhập văn bản từ 10 đến 20 ký tự.',
    },
    phone: {
      required: 'Vui lòng nhập số điện thoại di động.',
    },
  },
  alert: {
    docType: {
      selectType: 'Vui lòng chọn loại tài liệu.',
      selectDateRange: 'Vui lòng chọn khoảng thời gian báo cáo.',
      apiResponseError: 'Đã xảy ra lỗi khi xử lý phản hồi API.',
      creationError: 'Đã xảy ra lỗi khi tạo tài liệu.',
    },
    selectDocType: 'Vui lòng chọn loại tài liệu.',
    reportNeedsDates: 'Loại báo cáo yêu cầu chọn tất cả các khoảng thời gian thu thập dữ liệu.',
    startDateAfterEndDate: 'Ngày bắt đầu phải trước ngày kết thúc.',
    invalidFileTypeForAI: 'Chỉ có thể tải lên tệp PDF, Word, TXT, CSV để tạo timeline AI.',
    fileSizeExceededSimple: 'Kích thước tệp không được vượt quá 10MB.',
    errorNeedProjectId: 'Bạn phải chọn một dự án trước để tạo timeline.',
    aiTimelineCreatedSuccess:
      'Yêu cầu tạo timeline AI từ tệp đã được gửi. Nó sẽ được phản ánh ngay.',
    aiTimelineCreationFailed: 'Yêu cầu tạo timeline AI thất bại. Vui lòng thử lại sau.',
  },
  settlement: {
    settlementMonth: 'Tháng thanh toán',
    settlementDate: 'Ngày thanh toán',
    monthly: 'Hằng tháng',
    day: 'Ngày',
    projectTotalAmount: 'Tổng số tiền dự án',
    use: 'Sử dụng',
    currency: 'VND',
    previous: 'Trước',
    targets: 'Đối tượng',
    monthlyTotal: 'Tổng hằng tháng',
    totalSettlementAmount: 'Tổng số tiền thanh toán',
    download: 'Tải xuống',
    fullTime: 'Toàn thời gian',
    freelancer: 'Freelancer',
    targetAssignment: 'Chỉ định đối tượng',
    workingHours: 'Giờ làm việc',
    participationRate: 'Tỷ lệ tham gia',
    previousSalary: 'Lương trước',
    salaryAdjustment: 'Điều chỉnh lương',
    participationRateAdjustment: 'Điều chỉnh tỷ lệ tham gia',
    workingHoursAdjustment: 'Điều chỉnh giờ làm việc',
    desiredHourlyWage: 'Lương theo giờ mong muốn',
    hourlyWageAdjustment: 'Điều chỉnh lương theo giờ',
    monthlySettlementAmount: 'Số tiền thanh toán hàng tháng',
    totalSettlementAmountColumn: 'Tổng số tiền thanh toán',
    thousandWon: 'Nghìn VND',
    hours: 'Giờ',
    thousandWonPerHour: 'Nghìn VND / giờ',
    noStoriesInPeriod: 'Không có câu chuyện nào được hoàn thành trong khoảng thời gian này.',
    onlyDisplayedStoriesAdded: 'Chỉ những câu chuyện được hiển thị mới được thêm vào.',
    more: 'Thêm',
  },
};
